var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "980px" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c("v-icon", [_vm._v("remove_red_eye")]),
              _vm._v(" Ver permiso\n        "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "px-3" },
            [
              _c(
                "v-container",
                {
                  staticClass: "p-0",
                  staticStyle: { "min-width": "100%" },
                  attrs: { "grid-list-md": "" }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c("v-flex", { attrs: { xs12: "", md6: "" } }, [
                        _c("h3", { staticClass: "texto" }, [
                          _c("strong", [_vm._v("Número:")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.permiso.numero) +
                              "\n              "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { xs12: "", md6: "" } }, [
                        _c("h3", { staticClass: "texto" }, [
                          _c("strong", [_vm._v("Funcionario:")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.permiso.nombres) +
                              "\n              "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { xs12: "", md6: "" } }, [
                        _c("h3", { staticClass: "texto" }, [
                          _c("strong", [_vm._v("Tipo de papeleta:")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.permiso.tipo_permiso) +
                              "\n              "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.permiso.permiso.id_tipo_permiso == "87"
                        ? _c("v-flex", { attrs: { xs12: "", md6: "" } }, [
                            _c("h3", { staticClass: "texto" }, [
                              _c("strong", [_vm._v("Lugar de comisión :")]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.permiso.permiso.lugar) +
                                  "\n              "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permiso.permiso.id_tipo_permiso == "87" ||
                      _vm.permiso.permiso.id_tipo_permiso == "96" ||
                      _vm.permiso.permiso.id_tipo_permiso == "101"
                        ? _c("v-flex", { attrs: { xs12: "", md6: "" } }, [
                            _c("h3", { staticClass: "texto" }, [
                              _c("strong", [_vm._v("Motivo:")]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.permiso.permiso.motivo) +
                                  "\n              "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permiso.permiso.id_tipo_permiso == "90"
                        ? _c("v-flex", { attrs: { xs12: "", md6: "" } }, [
                            _c("h3", { staticClass: "texto" }, [
                              _c("strong", [_vm._v("Tipo de baja:")]),
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.permiso.id_tipo_permiso == 90 &&
                                      _vm.permiso.motivo !=
                                        "OTROS(ENFERMEDAD COMUN,RIESGO PROFESIONAL, RIESGO EXTRAORDINARIO)"
                                      ? _vm.permiso.motivo
                                      : _vm.permiso.motivo ==
                                          "OTROS(ENFERMEDAD COMUN,RIESGO PROFESIONAL, RIESGO EXTRAORDINARIO)" &&
                                        _vm.permiso.id_tipo_permiso == 90
                                      ? "OTROS"
                                      : "OTROS"
                                  ) +
                                  "\n              "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permiso.permiso.id_tipo_permiso == "61"
                        ? _c("v-flex", { attrs: { xs12: "", md6: "" } }, [
                            _c("h3", { staticClass: "texto" }, [
                              _c("strong", [_vm._v("Fecha de nacimiento:")]),
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.permiso.fecha_nac_muerte) +
                                  "\n              "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permiso.permiso.id_tipo_permiso == "61"
                        ? _c("v-flex", { attrs: { xs12: "", md6: "" } }, [
                            _c("h3", { staticClass: "texto" }, [
                              _c("strong", [_vm._v("Hora de nacimiento:")]),
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.permiso.hora_nac_muerte) +
                                  "\n              "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permiso.permiso.id_tipo_permiso == "6"
                        ? _c("v-flex", { attrs: { xs12: "", md6: "" } }, [
                            _c("h3", { staticClass: "texto" }, [
                              _c("strong", [_vm._v("Fecha de fallecimiento:")]),
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.permiso.fecha_nac_muerte) +
                                  "\n              "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permiso.permiso.id_tipo_permiso == "6"
                        ? _c("v-flex", { attrs: { xs12: "", md6: "" } }, [
                            _c("h3", { staticClass: "texto" }, [
                              _c("strong", [_vm._v("Hora de fallecimiento:")]),
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.permiso.hora_nac_muerte) +
                                  "\n              "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permiso.permiso.id_tipo_permiso == "12"
                        ? _c("v-flex", { attrs: { xs12: "", md6: "" } }, [
                            _c("h3", { staticClass: "texto" }, [
                              _c("strong", [_vm._v("Fecha de matrimonio:")]),
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm
                                      .$moment(_vm.permiso.fecha_nac_muerte)
                                      .format("DD-MM-YY")
                                  ) +
                                  "\n              "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permiso.permiso.id_tipo_permiso == "44"
                        ? _c("v-flex", { attrs: { xs12: "", md6: "" } }, [
                            _c("h3", { staticClass: "texto" }, [
                              _c("strong", [
                                _vm._v("Condición o estado crítico de salud:")
                              ]),
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.permiso.permiso.motivo) +
                                  "\n              "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permiso.permiso.id_estado == 9
                        ? _c("v-flex", { attrs: { xs12: "", md6: "" } }, [
                            _c("h3", { staticClass: "texto" }, [
                              _c("strong", [_vm._v("Motivo de la anulación:")]),
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.permiso.justificacion) +
                                  "\n              "
                              )
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h3", [_c("strong", [_vm._v("Detalles de papeleta")])]),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _vm.permiso.permiso.id_tipo_permiso == 87 ||
                      _vm.permiso.permiso.id_tipo_permiso == 96 ||
                      _vm.permiso.permiso.id_tipo_permiso == 88 ||
                      (_vm.permiso.permiso.id_tipo_permiso >= 37 &&
                        _vm.permiso.permiso.id_tipo_permiso <= 43)
                        ? _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-data-table", {
                                staticClass: "elevation-1",
                                attrs: {
                                  items: _vm.permiso_detalles2,
                                  "hide-actions": "",
                                  headers: _vm.headers_horas
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    props.item.fecha_salida
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    props.item.fecha_hasta
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_desde)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_hasta)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm
                                                      .$moment(
                                                        props.item.total_horas,
                                                        "HH:mm"
                                                      )
                                                      .format("HH:mm")
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1199824413
                                )
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.permiso.permiso.id_tipo_permiso == 8
                    ? _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-data-table", {
                                staticClass: "elevation-1",
                                attrs: {
                                  items: _vm.permiso_detalles2,
                                  "hide-actions": "",
                                  headers: _vm.headers_caja
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    props.item.fecha_salida
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    props.item.fecha_hasta
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm
                                                      .$moment(
                                                        props.item.hora_desde,
                                                        "HH:mm"
                                                      )
                                                      .subtract("00:20")
                                                      .format("HH:mm")
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_desde)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_hasta)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm
                                                      .$moment(
                                                        props.item.hora_hasta,
                                                        "HH:mm"
                                                      )
                                                      .add("00:20")
                                                      .format("HH:mm")
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm
                                                      .$moment(
                                                        props.item.total_horas,
                                                        "HH:mm"
                                                      )
                                                      .format("HH:mm")
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.permiso.id_tipo_permiso == 24
                                            ? _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        props.item.total_dias
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2670872612
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _vm.permiso.permiso.id_tipo_permiso == 14 ||
                          _vm.permiso.permiso.id_tipo_permiso == 105 ||
                          (_vm.permiso.permiso.id_tipo_permiso >= 98 &&
                            _vm.permiso.permiso.id_tipo_permiso <= 101) ||
                          _vm.permiso.permiso.id_tipo_permiso == 89 ||
                          _vm.permiso.permiso.id_tipo_permiso == 18
                            ? _c("v-data-table", {
                                staticClass: "elevation-1",
                                attrs: {
                                  items: _vm.permiso_detalles2,
                                  "hide-actions": "",
                                  headers: _vm.headers_dias_decimales
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    props.item.fecha_salida
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    props.item.fecha_hasta
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_desde)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_hasta)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.total_dias)
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  152919088
                                )
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _vm.permiso.permiso.id_tipo_permiso == 6 ||
                          _vm.permiso.permiso.id_tipo_permiso == 44 ||
                          _vm.permiso.permiso.id_tipo_permiso == 95 ||
                          _vm.permiso.permiso.id_tipo_permiso == 61 ||
                          _vm.permiso.permiso.id_tipo_permiso == 5 ||
                          _vm.permiso.permiso.id_tipo_permiso == 12 ||
                          _vm.permiso.permiso.id_tipo_permiso == 90
                            ? _c("v-data-table", {
                                staticClass: "elevation-1",
                                attrs: {
                                  items: _vm.permiso_detalles2,
                                  "hide-actions": "",
                                  headers: _vm.headers_dias
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    props.item.fecha_salida
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    props.item.fecha_hasta
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    props.item.total_dias
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3227130028
                                )
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.permiso.permiso.id_tipo_permiso == 94
                    ? _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-data-table", {
                                staticClass: "elevation-1",
                                attrs: {
                                  items: _vm.permiso_detalles2,
                                  "hide-actions": "",
                                  headers: _vm.headers_registro_asistencias
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    props.item.fecha_salida
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    props.item.fecha_hasta
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_desde)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_hasta)
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2487036984
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _vm.permiso.permiso.id_tipo_permiso == "24"
                            ? _c("v-data-table", {
                                staticClass: "elevation-1",
                                attrs: {
                                  items: _vm.permiso_detalles,
                                  "hide-actions": "",
                                  headers: _vm.headers
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _vm.permiso.permiso.id_tipo_permiso ==
                                          "24"
                                            ? _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        props.item.fecha_desde
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.permiso.permiso.id_tipo_permiso ==
                                          "24"
                                            ? _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        props.item.fecha_hasta
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_desde)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_hasta)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.total_dias)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    props.item.estado_detalle
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2234803421
                                )
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.permiso.tipo_permiso == "PERMISO A CUENTA DE VACACIÓN"
                    ? _c(
                        "v-layout",
                        [
                          _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("h4", [
                              _c("strong", [
                                _vm._v(
                                  "Total horas: " +
                                    _vm._s(_vm.horas_solicitadas.toFixed(2))
                                )
                              ])
                            ])
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.permiso.id_tipo_permiso == 88 ||
                  (_vm.permiso.id_tipo_permiso == 96 &&
                    _vm.permiso.compensa_tolerancia == 1)
                    ? _c("h3", [
                        _c("strong", [_vm._v("Detalles compensacion")])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.permiso.id_tipo_permiso == 88 ||
                  (_vm.permiso.id_tipo_permiso == 96 &&
                    _vm.permiso.compensa_tolerancia == 1)
                    ? _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-data-table", {
                                staticClass: "elevation-1",
                                attrs: {
                                  items: _vm.permiso_compensacion,
                                  "hide-actions": "",
                                  headers: _vm.headers2
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm
                                                      .$moment(
                                                        props.item.fecha_desde
                                                      )
                                                      .format("DD/MM/YYYY")
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm
                                                      .$moment(
                                                        props.item.fecha_hasta
                                                      )
                                                      .format("DD/MM/YYYY")
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm
                                                      .$moment(
                                                        props.item.hora_desde,
                                                        "HH:mm:ss"
                                                      )
                                                      .format("HH:mm")
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm
                                                      .$moment(
                                                        props.item.hora_hasta,
                                                        "HH:mm:ss"
                                                      )
                                                      .format("HH:mm")
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm
                                                      .$moment(
                                                        props.item
                                                          .diferencia_horas,
                                                        "HH:mm:ss"
                                                      )
                                                      .format("HH:mm")
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1182671064
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.permiso.id_tipo_permiso == 88 ||
                  (_vm.permiso.id_tipo_permiso == 96 &&
                    _vm.permiso.compensa_tolerancia == 1)
                    ? _c(
                        "v-layout",
                        { staticClass: "pa-2" },
                        [
                          _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("h4", [
                              _c("strong", [
                                _vm._v(
                                  "Total horas: " +
                                    _vm._s(_vm.total_horas_acomuladas)
                                )
                              ])
                            ])
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c("h2", [_c("strong", [_vm._v("Seguimiento de papeleta")])]),
              _vm._v(" "),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("v-data-table", {
                        staticClass: "elevation-1",
                        attrs: {
                          items: _vm.detalle_seguimiento,
                          "hide-actions": "",
                          headers: _vm.headers_detalle
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "items",
                            fn: function(props) {
                              return [
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(_vm._s(props.item.fecha_registro))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(_vm._s(props.item.estado))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(_vm._s(props.item.usuario))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(
                                    "  " +
                                      _vm._s(
                                        props.item.jefe &&
                                          (props.item.id_estado == 6 ||
                                            props.item.id_estado == 21) &&
                                          (_vm.permiso.id_tipo_permiso == 24 ||
                                            _vm.permiso.id_tipo_permiso == 14 ||
                                            _vm.permiso.id_tipo_permiso ==
                                              105 ||
                                            _vm.permiso.id_tipo_permiso == 94 ||
                                            _vm.permiso.id_tipo_permiso == 88 ||
                                            _vm.permiso.id_tipo_permiso == 87 ||
                                            _vm.permiso.id_tipo_permiso == 61 ||
                                            _vm.permiso.id_tipo_permiso == 12 ||
                                            _vm.permiso.id_tipo_permiso == 6 ||
                                            (_vm.permiso.id_tipo_permiso >=
                                              37 &&
                                              _vm.permiso.id_tipo_permiso <=
                                                43))
                                          ? props.item.jefe
                                          : (_vm.permiso.id_tipo_permiso ==
                                              90 ||
                                              _vm.permiso.id_tipo_permiso ==
                                                18 ||
                                              _vm.permiso.id_tipo_permiso ==
                                                95 ||
                                              _vm.permiso.id_tipo_permiso ==
                                                8 ||
                                              _vm.permiso.id_tipo_permiso ==
                                                96 ||
                                              _vm.permiso.id_tipo_permiso ==
                                                89 ||
                                              _vm.permiso.id_tipo_permiso ==
                                                100 ||
                                              _vm.permiso.id_tipo_permiso ==
                                                98 ||
                                              _vm.permiso.id_tipo_permiso ==
                                                101 ||
                                              _vm.permiso.id_tipo_permiso ==
                                                99) &&
                                            props.item.id_estado == 6
                                          ? "RECURSOS HUMANOS"
                                          : ""
                                      )
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "error", type: "submit" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.close()
                    }
                  }
                },
                [
                  _c("v-icon", [_vm._v("clear")]),
                  _vm._v("\n          Cerrar\n        ")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-658cba7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-658cba7e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/permiso/dialogs/VerPermisoReporte.vue
// module id = null
// module chunks = 